/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Skip_To_Confirm_ButtonInputs */



/**
* | output |
* | --- |
* | "Skip to Confirm" |
*
* @param {New_Project_Skip_To_Confirm_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_skip_to_confirm_button = /** @type {((inputs?: New_Project_Skip_To_Confirm_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Skip_To_Confirm_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Passer à la confirmation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Weiter zum Bestätigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vai alla conferma")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перейти к подтверждению")
	if (locale === "es") return /** @type {LocalizedString} */ ("Saltar para confirmar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("跳过确认")
	if (locale === "ja") return /** @type {LocalizedString} */ ("確認へスキップ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पुष्टि करने के लिए आगे बढ़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ir para Confirmar")
	return /** @type {LocalizedString} */ ("Skip to Confirm")
});